import React, { useEffect } from "react";
import ServiceFeePage from "../../components/FinancialManagement/ServiceFeePage";
import MainLayout from "../../components/Layout/MainLayout";

const ServiceFee = () => {
  useEffect(() => {
    document.title = "Service Fee - Prime Bridge Admin";
  }, []);
  return (
    <MainLayout>
      <ServiceFeePage />
    </MainLayout>
  );
};

export default ServiceFee;
